module.exports = __webpack_public_path__ + "static/media/w_w_hw_18.6ea24bdb.png";